export default __webpack_public_path__ + "static/WPS-P2P_IN-5905_05-02cafc19e4eb9545fb020dbb6202e35e.webp";